<template>
<div id="seat">
    <div @click="set_seatdata(item)" v-for="(item , index) in seat_list" :id="item.seat_name" :key="index+'seat_item'" v-bind:style="{left:item.position_x+'px' ,
        top:item.position_y+'px' , width: item.width_size+'px' , height: item.height_size+'px', 'line-height': item.line_height+'px', 'font-size': item.font_size+'px',
        'border': item.type_color,'background-color': item.background_color, color: seat_text_color,
        transform: 'rotate(' + item.rotate_angle + 'deg)'}" class="column">
        {{item.seat_name}}
    </div>
    <div @click="go_move_groom_page(item)" v-for="(item , index) in groom_room_list" :id="item.groom_name" :key="index+'groom_item'" v-bind:style="{left:item.position_x+'px' ,
        top:item.position_y+'px' , width: item.width_size+'px' , height: item.height_size+'px', 'line-height': item.line_height+'px', 'font-size': item.font_size+'px',
        'border': item.type_color, 'background-color': item.background_color, color: seat_text_color,
        transform: 'rotate(' + item.rotate_angle + 'deg)'}" class="column">
        {{item.groom_name}}
    </div>

    <!-- <div class="choice-seat" v-if="data_set">
        <div class="choice-seat-wrap">
            <div>{{seat_info.seat_name}}번 좌석</div><br>
            <div><img src="../../assets/image/info.png" alt=""> {{seat_info.seat_type_name}}</div>
            <div class="btn-choice" @click="send_data">확인</div>
        </div>
    </div> -->

</div>
</template>

<script>
import EventBus from "./EventBus";
// 사용자 정의 모듈.
import * as config from '../../javascript/config';

import vue from 'vue';

var self = this;
export default {
    name: 'seat',
    props: ['map_group_id', 'from_pop', 'click_event', 'from_fornt_pop'],

    data() {
        return {
            // new logic data
            seat_all_list: [],
            seat_list: [],
            type_color: [],
            groom_type_color: [],
            my_seat_list: [],
            groom_room_list: [],
            groom_all_list: [],
            my_groom: [],
            data_set: false,
            seat_info: {},
            From_front: '',
            first_loading_seat_count:0,
            seat_text_color: '#fff'
        }

    },
    methods: {
        refresh_from_main(time, callback) {
            this.get_seat_data(); // 최초 좌석 셋팅
            this.get_groom_room_data(); // 그룹룸정보
            setTimeout(function() {
                callback(false);
            }, time);
        },
        set_seatdata(item) { // 스마트출입 자리이동 좌석선택
            this.$emit("select_seat_data", item);
            if (this.from_fornt_pop) {
                this.go_payment(item);
            }
        },
        send_data(item) {
            this.go_payment(item);
        },
        go_payment(item) {
            // 내좌석 팝업이 떠잇는 상태에서의 좌석 클릭이라면 set_move_seat() 함수 호출
            if (this.from_pop) {
                var from = this.$store.getters['getFrom_front'];
                this.set_move_seat(item);
                return;
            }
            // 로그인 상태여부 체크
            var router = this.$router;
            if (!this.$store.state.login_chk) {
                this.$store.commit('set_Last_URL', '');
                this.$store.commit('change_main_tab_chk', {
                    value: 0
                });
                // router.push('/login');
            } else {

                // 내가 사용중인 좌석이 있다면
                if (this.my_seat_list.length > 0) {
                    // 내가 사용중인 좌석들 중에 현재 클릭한 좌석의 seat id 가 일치하면 내좌석을 클릭한것이므로,                        
                    this.$store.commit('setExtention_flag', {
                        value: true
                    });
                    var myseat_id = "";
                    this.$store.commit('set_my_seat_data', {
                        seat_id: this.my_seat_list[0].seat_id,
                        seat_name: this.my_seat_list[0].seat_name,
                        seat_use_id: this.my_seat_list[0].seat_use_id,
                        use_start_datetime: this.my_seat_list[0].use_start_datetime,
                        use_end_datetime: this.my_seat_list[0].use_end_datetime,
                        goods_end_datetime: this.my_seat_list[0].goods_end_datetime,
                        left_time: this.my_seat_list[0].left_time,
                        use_total_time: this.my_seat_list[0].use_total_time,
                        map_group_id: this.map_group_id,
                        main_seat_type_code: item.main_seat_type_code,
                        // 코드 추가 - 2020-11-26
                        seat_type_code: item.seat_type_code,
                    });
                    this.$store.commit('set_select_seat', {
                        seat_id: item.seat_id,
                        seat_name: item.seat_name,
                        seat_type_code: item.seat_type_code,
                        seat_type_name: item.seat_type_name,
                        seat_status_code: item.seat_status_code
                    });
                    for (let i = 0; i < this.my_seat_list.length; i++) {
                        if (item.seat_id == this.my_seat_list[i].seat_id) {
                            // store set_my_seat_data 배열에 데이터 셋팅
                            // 그후 내좌석 으로 무얼할지 진행하는 popup 호출
                            
                            // 코드 추가 2020-11-30
                            if (this.from_fornt_pop) {
                                return;
                            }else{
                                const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_USE_SEAT_TYPE,
                                };
                                this.$store.commit('set_popup_type', alert_param);
                            }
                            
                            // var store_pay_info = this.$store.getters['getStore_pay_info'];                         
                            // if (store_pay_info) {
                            //     const alert_param = {
                            //         code: this.$store.getters['get_popup_code'].POPUP_USE_SEAT_TYPE,
                            //     };
                            //     this.$store.commit('set_popup_type', alert_param);
                            // } else {
                            //     const alert_param = {
                            //         code: this.$store.getters['get_popup_code'].POPUP_SEAT_USE_PRODUCT_COUPON_LIST,
                            //     }
                            //     this.$store.commit('set_popup_type', alert_param);
                            // }

                            return;
                        }
                    }
                    var my_seat_type = this.my_seat_list[0].seat_type_code;
                    var sel_seat_type = item.seat_type_code;
                    var message = "";
                    if (my_seat_type == sel_seat_type && item.seat_status_code == "SEAT_AVAILABLE") { // 내가 이용하는좌석이 있고 다른 빈좌석을 선택하는 경우


                        var sel_seat_id = item.seat_id;
                        var sel_seat_name = item.seat_name;
                        var my_seat_id = this.my_seat_list[0].seat_id;
                        var my_seat_use_id = this.my_seat_list[0].seat_use_id;
                        this.$store.commit('set_main_page_update_seat', {
                            'sel_seat_id': sel_seat_id,
                            'sel_seat_name': sel_seat_name,
                            'my_seat_id': my_seat_id,
                            'my_seat_use_id': my_seat_use_id
                        });
                        // 코드 추가 2020-11-30
                        if (this.from_fornt_pop) { // 스마트출입에서 자리이동시 해당 로직 으로 이동 2020.11.30 cjb
                            this.$parent.seat_move_res(5, item);
                            const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_SEAT_MOVE,
                            };
                            this.$store.commit('set_popup_type', alert_param);
                            return false;
                        } else {
                            const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                                message: `이용중인 좌석이 있습니다.<br /> 해당 좌석을 선택해 주세요.`,
                                router: '',
                                image_type: 'warning'
                            };
                            this.$store.commit('set_popup_type', alert_param);
                            return;

                        }
                    } else {
                        if (this.from_fornt_pop) {
                            this.$parent.seat_move_res(5, item);
                        }
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: `해당 좌석으로 이동이 불가능합니다. `,
                            router: '',
                            image_type: 'warning'
                        };
                        this.$store.commit('set_popup_type', alert_param);
                        return;
                    }
                    // 내가 사용중인 좌석이 있지만 , 클릭한 좌석이 내 좌석이 아닐경우 현재 이미 사용중인 좌석이 있으므로 더이상의 좌석 즉시적용 구매 프로세스 호출 방지
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `현재 이미 사용중인 좌석이있습니다. `,
                        router: '',
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    return;
                }

                // 현재 내가 사용하고 있는 좌석이 없는 상태에서 다른사람이 사용하고 있는 좌석을 클릭했을시 이미 사용하고 있다는 메세지를 보여주는 popup 호출
                if (item.seat_status_code != "SEAT_AVAILABLE") {
                    const type = config.REQ_ANOTHER_SEAT_USE_ENDTIME;
                    const data = {
                        seat_id: item.seat_id
                    };
                    this.$store.dispatch(type.action_name, {
                        type: type,
                        data: data
                    }).then(response => {
                        // 데이터를 담아낸뒤

                        if (response.result) {
                            var end_date_time = "";
                            if (response.data.length != 0) {
                                end_date_time = response.data[0].use_end_datetime;
                                var msg = `이미 사용중인 좌석입니다.<br>  <p>종료예상시간 : ` + end_date_time + `</p>`
                            }else{
                                var msg = `결제 진행중 좌석입니다. 다른좌석을 이용해주세요.`
                            }
                            const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                                message: msg,
                                router: '',
                            };
                            this.$store.commit('set_popup_type', alert_param);
                        }
                    }).catch(function (error) {
                        console.log('error=============>', error);
                    });
                    return;
                } else if (item.seat_status_code == "SEAT_AVAILABLE") {
                    const type = config.REQ_USING_SEAT_CHECK;
                    const data = {
                        seat_id: item.seat_id
                    };

                    this.$store.dispatch(type.action_name, {
                        type: type,
                        data: data
                    }).then(response => {
                        // 데이터를 담아낸뒤
                        if (response.result) {
                            var end_date_time = "";
                            var seat_status_code = "";
                            if (response.data.length != 0) {
                                end_date_time = response.data[0].use_end_datetime;
                                seat_status_code = response.data[0].seat_status_code;
                            }
                            if (seat_status_code !== "SEAT_AVAILABLE") {
                                const alert_param = {
                                    code: this.$store.getters['get_popup_code'].POPUP_USING_CHECK
                                };
                                this.$store.commit('set_popup_type', alert_param);
                                return;
                            }else{
                                // 내가 사용하고있는 좌석이 없고 선택한좌석이 비어있는 좌석이라면 , store 에 선택한 좌석의 데이터를 셋팅
                                this.$store.commit('set_select_seat', {
                                    seat_id: item.seat_id,
                                    seat_name: item.seat_name,
                                    seat_type_code: item.seat_type_code,
                                    seat_type_name: item.seat_type_name,
                                    seat_status_code: item.seat_status_code
                                });
                                this.$store.state.select_my_seat[0].seat_name = item.seat_name;
                                var store_pay_info = this.$store.getters['getStore_pay_info'];               
                                if (store_pay_info) {
                                    router.push('/payment-seat');
                                } else {
                                    const alert_param = {
                                        code: this.$store.getters['get_popup_code'].POPUP_SEAT_USE_PRODUCT_COUPON_LIST,
                                    }
                                    this.$store.commit('set_popup_type', alert_param);
                                }
                                // 그뒤 즉시적용 구매 프로세스로 이동
                            }

                        }
                    }).catch(function (error) {
                        console.log('error=============>', error);
                    });
                }
                
                
            }
        },
        set_move_seat(item) {
            // 좌석이동 popup 프로세스가 진행중인 상태라면 , 현재 클릭된 좌석의 데이터를 비교한다.
            for (let i = 0; i < this.my_seat_list.length; i++) {
                // 선택한 좌석이 현재내가 사용중인 좌석이라면 이동할수없다는 popup 호출
                if (item.seat_id == this.my_seat_list[i].seat_id) {

                    if (this.from_fornt_pop) {
                        this.$parent.seat_move_res(0, item);
                    }
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_UNAVAILABLE_MOVE_SEAT,
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    return;
                }
                if (item.seat_type_code != this.my_seat_list[i].seat_type_code) {

                    if (this.from_fornt_pop) {
                        this.$parent.seat_move_res(1, item);
                    }
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_UNAVAILABLE_MOVE_SEAT,
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    return;
                }
                if (item.seat_id != this.my_seat_list[i].seat_id && item.seat_status_code == 'SEAT_AVAILABLE' && item.seat_type_code == this.my_seat_list[i].seat_type_code) {
                    // popup 의 select_seat_data 이름으로 등록되어있는 popup 쪽 함수를 호출하면서 방금 클릭한 좌석의 정보를 보낸다(item)                        
                    if (this.from_fornt_pop) {
                        this.$parent.seat_move_res(2, item);
                    }
                    this.$emit("select_seat_data", item);
                }
            }

        },
        get_seat_data() {
            // this.type_color = this.$store.getters['get_seat_type_color'];

            const type = config.REQ_SEAT_USER_GET_LIST;
            const req_data = {
                map_group_id: this.map_group_id
            };
            this.$store.dispatch(type.action_name, {
                type: type,
                data: req_data
            }).then(response => {
                this.$store.commit('set_page_header_init', {
                    style: 'block'
                });
                if (response.data.length > 0) {
                    this.seat_all_list = response.data;

                    for (let i = 0; i < this.seat_all_list.length; i++) {
                        for (let z = 0; z < this.seat_all_list[i].seats.length; z++) {
                            if (this.seat_all_list[i].seats[z].code_value.indexOf(",") != -1) {
                                var color = this.seat_all_list[i].seats[z].code_value.split(',');
                                this.seat_all_list[i].seats[z].code_value = color[0];
                                this.seat_all_list[i].seats[z].code_value_text = color[1];
                            }
                        }
                    }
                    for (let i = 0; i < this.seat_all_list.length; i++) {
                        if (this.map_group_id == this.seat_all_list[i].map_group_id) {
                            this.seat_list = this.seat_all_list[i].seats;
                            break;
                        }
                    }

                    for (let i = 0; i < this.seat_list.length; i++) {
                        for (let z = 0; z < this.type_color.length; z++) {
                            if (this.seat_list[i].seat_type_name == this.type_color[z].seat_type_name) {
                                this.seat_list[i].type_color = this.seat_list[i].border_size + "px solid " + this.type_color[z].color;
                            }
                        }
                    }
                } else {
                    this.seat_all_list = [];
                    this.seat_list = [];
                }
                this.reset_seat_type_status();
            }).then(() => {
                // this.reset_seat_type_status();  // 타입 & 상태 정보
            }).catch(function (error) {
                console.log('error=============>', error);
            });

        },
        reset_seat_type_status() { // 좌석 상태표시 사용 o
            var common_status_color_list = this.$store.getters['get_seat_status_color'];

            for (var i = 0; i < common_status_color_list.length; i++) {
                var colorStr = "";
                var color = common_status_color_list[i].color || "";
                if (color == "" || color == "null") {
                    common_status_color_list[i].color = "#000000";
                    colorStr = "#000000";
                } else {
                    if (color.indexOf(",") != -1) {
                        common_status_color_list[i].color = common_status_color_list[i].color.split(',')[0];
                        colorStr = common_status_color_list[i].color.split(',')[0];
                    } else {
                        colorStr = common_status_color_list[i].color
                    }
                }
                common_status_color_list[i].style = colorStr;
            }

            for (var i = 0; i < this.seat_list.length; i++) {
                var i_code_name = this.seat_list[i].code_name;
                var i_status_code = this.seat_list[i].seat_status_code;
                for (var j = 0; j < common_status_color_list.length; j++) {
                    var j_code_name = common_status_color_list[j].code_name;
                    var j_status_code = common_status_color_list[j].status_code;
                    if ((i_code_name == j_code_name) && (i_status_code == j_status_code)) {
                        this.seat_list[i].background_color = common_status_color_list[j].style;
                    }
                }
            }
            // 내좌석 정보관련
            if (this.$store.state.login_chk) {
                // 현재 사용중인 나의 좌석 정보를 가져온다.
                const type = config.REQ_SEAT_USE_GET_LIST;
                const data = {};
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                }).then(response => {
                    this.my_seat_list = response.data;
                    var temp_my_seat_color = this.$store.getters['get_my_color']['my_seat_color']

                    var status_color = this.$store.getters['get_seat_status_color'];
                    var using_color;

                    if (typeof temp_my_seat_color == 'undefined' || temp_my_seat_color == '') {
                        temp_my_seat_color = 'red';
                    } else {
                        if (temp_my_seat_color.indexOf(",") != -1) {
                            var color = temp_my_seat_color.split(',');
                            temp_my_seat_color = color[0];
                        }
                    }

                    if (this.my_seat_list.length > 0) {
                        for (let i = 0; i < this.my_seat_list.length; i++) {
                            for (let z = 0; z < this.seat_list.length; z++) {
                                if (this.seat_list[z].seat_id == this.my_seat_list[i].seat_id) {
                                    this.seat_list[z].background_color = temp_my_seat_color;
                                    vue.set(this.seat_list, z, this.seat_list[z]);
                                }
                            }
                        }
                    }
                    var from = this.$store.getters['getFrom_front'];
                    if (from.click === "move_seat" || from.click === "end_seat" || from.click === "use_extension") {
                        this.go_payment(this.my_seat_list[0]);
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });

            }
            ++this.first_loading_seat_count;

            if(this.first_loading_seat_count == 1){
                this.$emit("first_loading_seat");
            }        

        },
        get_groom_room_data() {
            // 그룹룸 정보
            this.groom_type_color = this.$store.getters['get_groom_type_color'];
            if (this.map_group_id != null && this.map_group_id != '') {
                const req_type = config.REQ_SEAT_GROOM_GET_LIST;
                const req_groom_data = {};
                req_groom_data.map_group_id = this.map_group_id;
                this.$store.dispatch(req_type.action_name, {
                    type: req_type,
                    data: req_groom_data
                }).then(response => {
                    if (response.result) {
                        this.groom_room_list = response.data;
                        for (let i = 0; i < this.groom_room_list.length; i++) {
                            for (let z = 0; z < this.groom_type_color.length; z++) {
                                if (this.groom_room_list[i].type_name == this.groom_type_color[z].type_name) {
                                    this.groom_room_list[i].type_color = this.groom_room_list[i].border_size + "px solid " + this.groom_type_color[z].color;
                                }
                            }
                        }
                    }
                    this.reset_groom_type_status();

                    if (this.$store.state.login_chk) {

                        // 현재 사용중인 나의 좌석 정보를 가져온다.
                        const type = config.REQ_GROOM_USE_CHECK;
                        const data = {};
                        data.store_id =
                            this.$store.dispatch(type.action_name, {
                                type: type,
                                data: data
                            }).then(response => {
                                var temp_my_groom_color = this.$store.getters['get_my_color']['my_seat_color'];
                                this.my_groom = response.data
                                for (let i = 0; i < this.groom_room_list.length; i++) {
                                    for (let j = 0; j < this.my_groom.length; j++) {
                                        if (this.groom_room_list[i].groom_id === this.my_groom[j].groom_id) {
                                            this.groom_room_list[i].type_color = this.groom_room_list[i].background_color = temp_my_groom_color
                                        }
                                    }
                                    vue.set(this.groom_room_list, i, this.groom_room_list[i]);
                                }
                            }).catch(function (error) {
                                console.log('error=============>', error);
                            });
                    }

                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }
        },
        // 그룹룸 선택
        go_move_groom_page(item) {
            this.$store.commit('set_select_groom', {
                groom_id: item.groom_id
            });
            if (item.groom_status_code == 'GROOM_AVAILABLE') {
                var groom_info = {};
                groom_info.groom_id = item.groom_id;
                groom_info.before_groom_id = item.groom_id;
                groom_info.groom_status_code = item.groom_status_code;
                groom_info.groom_name = item.groom_name;
                groom_info.groom_info = item.groom_info;
                groom_info.groom_seat_count = item.seat_count;
                groom_info.groom_type_id = item.groom_type_id;
                groom_info.min_user_count = item.min_user_count;
                groom_info.type_name = item.type_name;
                groom_info.groom_goods_group_id = item.groom_goods_group_id;
                groom_info.groom_goods_name = item.groom_goods_name;
                groom_info.selection_plan_code = item.selection_plan_code;
                groom_info.goods_group_name = item.goods_group_name;
                this.$store.commit('set_main_page_tab_code', {
                    'tab_code': 'GROOM',
                    'groom_info': groom_info
                });
            }
            else if(item.groom_status_code === 'GROOM_UNAVAILABLE') {
   
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `현재 이용 하실 수 없습니다. `,
                    router: '',
                    image_type: 'warning'
                }
                this.$store.commit('set_popup_type', alert_param);
                return;
            } else {
                if (this.groom_status_code != 'GROOM_AVAILABLE') {

                    if (this.my_groom.length > 0) {

                        for(let i = 0; i < this.my_groom.length; i++){
                            if(item.groom_id == this.my_groom[i].groom_id){
                                this.$store.commit('set_my_groom_data', {
                                    groom_id: this.my_groom[i].groom_id,
                                    groom_name: this.my_groom[i].groom_name,
                                    groom_use_id: this.my_groom[i].groom_use_id,
                                    use_start_datetime: this.my_groom[i].use_start_datetime,
                                    use_end_datetime: this.my_groom[i].use_end_datetime
                                });
                            }
                        }
                        this.$store.commit('set_select_groom', {
                            groom_id: item.groom_id,
                            groom_name: item.groom_name,
                            groom_type_id: item.groom_type_id
                        });

                        let flag = false
                        for (let i = 0; i < this.my_groom.length; i++) {
                            if (item.groom_id === this.my_groom[i].groom_id) {
                                const alert_param = {
                                    code: this.$store.getters['get_popup_code'].POPUP_USE_TYPE
                                };
                                this.$store.commit('set_popup_type', alert_param);
                                return;

                                flag = true;
                            }
                        }
                        if (flag === false) {

                            var groom_info = {};
                            groom_info.groom_id = item.groom_id;
                            groom_info.before_groom_id = item.groom_id;
                            groom_info.groom_status_code = item.groom_status_code;
                            groom_info.groom_name = item.groom_name;
                            groom_info.groom_info = item.groom_info;
                            groom_info.groom_seat_count = item.seat_count;
                            groom_info.groom_type_id = item.groom_type_id;
                            groom_info.min_user_count = item.min_user_count;
                            groom_info.type_name = item.type_name;
                            groom_info.groom_goods_group_id = item.groom_goods_group_id;
                            groom_info.groom_goods_name = item.groom_goods_name;
                            groom_info.selection_plan_code = item.selection_plan_code;
                            groom_info.goods_group_name = item.goods_group_name;
                            this.$store.commit('set_main_page_tab_code', {
                                'tab_code': 'GROOM',
                                'groom_info': groom_info
                            });

                        }

                    } else {
                        var groom_info = {};
                        groom_info.groom_id = item.groom_id;
                        groom_info.before_groom_id = item.groom_id;
                        groom_info.groom_status_code = item.groom_status_code;
                        groom_info.groom_name = item.groom_name;
                        groom_info.groom_info = item.groom_info;
                        groom_info.groom_seat_count = item.seat_count;
                        groom_info.groom_type_id = item.groom_type_id;
                        groom_info.min_user_count = item.min_user_count;
                        groom_info.type_name = item.type_name;
                        groom_info.groom_goods_group_id = item.groom_goods_group_id;
                        groom_info.groom_goods_name = item.groom_goods_name;
                        groom_info.selection_plan_code = item.selection_plan_code;
                        groom_info.goods_group_name = item.goods_group_name;
                        this.$store.commit('set_main_page_tab_code', {
                            'tab_code': 'GROOM',
                            'groom_info': groom_info
                        });
                    }

                }
            }
        },
        reset_groom_type_status() { // 그룹룸 상태표시 사용 o
            // 그룹룸
            var common_status_groom_color_list = this.$store.getters['get_groom_status_color'];
            for (var i = 0; i < common_status_groom_color_list.length; i++) {
                var colorStr = "";
                var color = common_status_groom_color_list[i].color || "";
                if (color == "" || color == "null") {
                    common_status_groom_color_list[i].color = "#000000";
                    colorStr = "#000000";
                } else {
                    if (color.indexOf(",") != -1) {
                        common_status_groom_color_list[i].color = common_status_groom_color_list[i].color.split(',')[0];
                        colorStr = common_status_groom_color_list[i].color.split(',')[0];
                    } else {
                        colorStr = common_status_groom_color_list[i].color
                    }
                }
                common_status_groom_color_list[i].style = colorStr;
            }

            for (var i = 0; i < this.groom_room_list.length; i++) {
                var i_code_name = this.groom_room_list[i].code_name;
                var i_status_code = this.groom_room_list[i].groom_status_code;
                for (var j = 0; j < common_status_groom_color_list.length; j++) {
                    var j_status_code = common_status_groom_color_list[j].status_code;
                    if (i_status_code == j_status_code) {
                        this.groom_room_list[i].background_color = common_status_groom_color_list[j].style;
                    }
                }
            }
            var groom_cnt = this.groom_room_list.length;
            this.$store.commit('set_store_groom_cnt', {
                'groom_cnt': groom_cnt
            });
        },
        get_seat_type_color_count() {
            const type = config.REQ_SEAT_USER_GET_TYPE_COLOR_LIST;
            const req_data = {
                map_group_id: this.map_group_id
            };
            this.$store.dispatch(type.action_name, {
                type: type,
                data: req_data
            }).then(response => {
                this.$store.commit('set_seat_type_color', response.data);
                this.type_color = response.data
            }).catch(function (error) {
                console.log('error=============>', error);
            });
        }, 
    },
    mounted() {
        this.get_seat_type_color_count();
        this.get_seat_data(); // 최초 좌석 셋팅
        this.get_groom_room_data(); // 그룹룸정보    
        this.seat_text_color = this.$store.state.my_color.seat_text_color
    },
    computed: {
        get_seat_move_flag() {
            return this.$store.getters.get_seat_move_flag;
        },
        get_groom_move_flag() {
            return this.$store.getters.get_groom_move_flag;
        },
    },
    watch: {
        // 맵이 변경됫을경우
        map_group_id(id) {
            this.map_group_id = id;
            this.get_seat_data();
            this.get_groom_room_data(); // 그룹룸정보
        },
        get_seat_move_flag(val, OldVal) {
            this.get_seat_data();
            this.get_groom_room_data(); // 그룹룸정보
        },
        get_groom_move_flag(val, OldVal) {
            this.get_seat_data();
            this.get_groom_room_data(); // 그룹룸정보
        },
    },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/components/seat.vue